import { z } from 'zod'

export const configSchema = z.strictObject({
  runtimeUrl: z.string(),
  agent: z.string(),
})

export type Config = z.infer<typeof configSchema>
